import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FounderAndAdvisorService {

  constructor(private http: HttpClient) { }

  addFounderAndAdvisor(data) {
    return this.http.post(`${environment.apiUrl}founder`,data);
  }

  updateFounderAndAdvisor(id,data) {
    return this.http.put(`${environment.apiUrl}founder/${id}`,data);
  }

  getFounderAndAdvisorById(id:string) {
    return this.http.get(`${environment.apiUrl}founder/${id}`);
  }

  getFounderAndAdvisors(query:string) {
    return this.http.get(`${environment.apiUrl}founder${query}`);
  }
}
